import React from 'react';

import { Position } from '../../../shared/modal/PositionModal';
import { FieldConfigModal } from './FieldConfigModal';

interface RefModalProps {
    isOpen: boolean;
    closeModal: () => void;
    position: Position | null;
    refLabel: string;
    updateRef: (val: string) => void;
    disableInputs: boolean;
}

export const RefModal: React.FC<RefModalProps> = ({ closeModal, isOpen, position, updateRef, refLabel, disableInputs }) => (
    <FieldConfigModal
        isOpen={isOpen}
        position={position}
        closeModal={closeModal}
        value={refLabel}
        updateValue={updateRef}
        disabled={disableInputs}
        headerLabel='Reference'
        description='The reference is displayed to a user in relation to the field it is added to, which might reference a particular clause or reference point of the document. It is different to providing a description but displayed in a similar way.'
        placeholder='Add a ref...'
        testId='ref'
    />
);
